import React, { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Send } from "lucide-react";

const InlineCapture = () => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    const raw = text.trim();
    if (!raw || busy) return;
    setBusy(true);
    try {
      const prep = await api.prepareCapture(raw);
      const e2 = prep.enriched;
      const res = await api.commitCapture({
        raw_text: raw,
        content: e2.rewritten || raw,
        business: e2.business,
        priority: e2.priority,
        due_string: e2.due_string,
        person: e2.person,
        is_waiting_on: e2.is_waiting_on,
        project_id: e2.project_id,
        source: "inline",
      });
      toast("Task created in Todoist", { description: `[${e2.business}] ${e2.rewritten?.slice(0, 60) || raw.slice(0, 60)}` });
      setText("");
      window.dispatchEvent(new CustomEvent("operator:sync"));
    } catch (err) {
      toast("Create failed", { description: err?.response?.data?.detail || "Try Quick Capture for more control." });
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="op-panel p-3 flex items-center gap-3" data-testid="inline-capture">
      <span className="op-tag pl-2 shrink-0 hidden sm:inline">WHAT NEEDS TO GET DONE?</span>
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Type it, we'll route + create it in Todoist…"
        className="op-input flex-1 !py-2"
        disabled={busy}
        data-testid="inline-capture-input"
      />
      <button
        type="submit"
        disabled={busy || !text.trim()}
        data-testid="inline-capture-add"
        className="op-btn op-btn--primary inline-flex items-center gap-2 shrink-0 disabled:opacity-40"
      >
        <Send size={12} />
        {busy ? "ADDING…" : "ADD"}
      </button>
    </form>
  );
};

export default InlineCapture;
